import React from 'react';

interface SliderIndicatorsProps {
  total: number;
  current: number;
}

const SliderIndicators = ({ total, current }: SliderIndicatorsProps) => {
  return (
    <div className="absolute bottom-4 right-4 flex gap-2">
      {[...Array(total)].map((_, index) => (
        <div
          key={index}
          className={`w-2 h-2 rounded-full transition-all duration-300 ${
            index === current 
              ? 'bg-white scale-125' 
              : 'bg-white/50 scale-100'
          }`}
        />
      ))}
    </div>
  );
};

export default SliderIndicators;